export default __webpack_public_path__ + "static/media/45.c6ed2e39.jpg";